import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredGoldCoin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <ellipse
      cx={6.80702}
      cy={7.00004}
      rx={6.47364}
      ry={6.66667}
      fill="#E5A200"
    />
    <ellipse
      cx={7.19301}
      cy={7.00004}
      rx={6.47364}
      ry={6.66667}
      fill="#FFCA12"
    />
    <ellipse
      cx={7.18271}
      cy={7.0001}
      rx={5.08371}
      ry={5.23265}
      fill="#E5A200"
    />
    <ellipse
      cx={7.01529}
      cy={7.0001}
      rx={4.91629}
      ry={5.23265}
      fill="#F4BD00"
      fillOpacity={0.8}
    />
    <g filter="url(#filter0_d_8239_3)">
      <path
        d="M10.1067 4.15865C9.13488 3.17403 8.22645 2.96228 7.20182 2.96228C4.42371 2.96228 3.15613 4.9527 3.15613 6.89018C3.15613 8.82767 4.26526 10.7863 7.19126 10.7863C8.61728 10.7863 9.90599 10.2781 10.3708 9.33586V6.0432H6.75817V7.68423H8.62785V8.63709C8.20532 8.94413 7.59266 9.01824 7.20182 9.01824C5.71241 9.01824 5.21595 7.84304 5.21595 6.89018C5.21595 5.43972 5.99762 4.71978 7.20182 4.71978C7.69829 4.71978 8.35321 4.85741 8.89193 5.36561L10.1067 4.15865Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_8239_3"
        x={3.15613}
        y={2.96228}
        width={7.2146}
        height={8.8241}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8239_3"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8239_3"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredGoldCoin)
const IconSvgColouredGoldCoin = createIcon(ForwardRef, 'SvgColouredGoldCoin')
export default IconSvgColouredGoldCoin
